import { Grid, Stack, Skeleton, Typography, Box } from '@mui/material'
import React from 'react'

const MAX_COLUMN = 6
const MAX_LINE = 4

const WIDTH_ELEMENT = '100%'

function renderColumns() {
  const array = []
  for (let index = 0; index < MAX_COLUMN; index += 1) {
    array.push(index)
  }

  return array.map((item) => {
    const key = `column-${item}`
    return (
      <Stack
        key={key}
        flexDirection="row"
        gap="0.4rem"
        width={WIDTH_ELEMENT}
        alignItems="center"
        justifyContent="flex-start"
      >
        <Skeleton width="100%">
          <Typography>.</Typography>
        </Skeleton>
      </Stack>
    )
  })
}

function renderCels() {
  const array = []
  for (let index = 0; index < MAX_COLUMN; index += 1) {
    array.push(index)
  }
  return array.map((item) => {
    const key = `line-${item}`
    return (
      <Stack
        key={key}
        flexDirection="row"
        gap="0.5rem"
        width={WIDTH_ELEMENT}
        alignItems="center"
        justifyContent="center"
      >
        <Skeleton variant="rectangular" height="1rem" width="100%">
          <Typography>.</Typography>
        </Skeleton>
      </Stack>
    )
  })
}

function renderLines() {
  const array = []
  for (let index = 0; index < MAX_LINE; index += 1) {
    array.push(index)
  }

  return array.map((item) => {
    const key = `line-${item}`
    return (
      <Box
        key={key}
        display="flex"
        flexDirection="row"
        borderBottom={2}
        borderColor="divider"
        gap="0.5rem"
        height="2rem"
        flexWrap="nowrap"
      >
        {renderCels()}
      </Box>
    )
  })
}

function ManagementEventsSkeleton() {
  return (
    <Stack component="div" flexDirection="column" gap="1.5rem">
      <Grid container height={60}>
        <Skeleton height="100%" width="40%" />
      </Grid>
      <Box display="flex" flexDirection="column">
        <Grid container height={20}>
          <Skeleton height="100%" width="100%" />
        </Grid>
        <Grid container height={20}>
          <Skeleton height="100%" width="80%" />
        </Grid>
      </Box>

      <Stack flexDirection="row" gap="1rem">
        <Grid container height="5rem" width="100%">
          <Skeleton height="100%" width="100%" />
        </Grid>
      </Stack>

      <Stack
        id="skeleton-conversion-report-table-container"
        data-testid="skeleton-conversion-report-table-container"
        padding={1}
      >
        <Stack flexDirection="row" gap="1rem">
          <Grid container height="3rem" width="20%">
            <Skeleton height="100%" width="100%" />
          </Grid>
        </Stack>
        <Stack
          id="skeleton-conversion-report-table"
          data-testid="skeleton-conversion-report-table"
          flexDirection="column"
          gap="1rem"
          padding={2}
          border={1}
          borderColor="#DDD"
        >
          <Box
            display="flex"
            flexDirection="row"
            borderBottom={2}
            borderColor="#E5E5E5"
            mt="1rem"
            gap="0.5rem"
            flexWrap="nowrap"
          >
            {renderColumns()}
          </Box>
          {renderLines()}
        </Stack>
      </Stack>
    </Stack>
  )
}

export default ManagementEventsSkeleton
